function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 1.25,
  y: 13.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 1.25,
  y: 16.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 4.25,
  y: 7.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 4.25,
  y: 10.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 4.25,
  y: 13.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 4.25,
  y: 16.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 4.25,
  y: 19.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 4.25,
  y: 22.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 7.25,
  y: 4.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 7.25,
  y: 7.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 7.25,
  y: 10.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 7.25,
  y: 13.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 7.25,
  y: 16.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 7.25,
  y: 19.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 7.25,
  y: 22.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 7.25,
  y: 25.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 10.25,
  y: 4.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 10.25,
  y: 7.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 10.25,
  y: 10.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 10.25,
  y: 13.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 10.25,
  y: 16.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 10.25,
  y: 19.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 10.25,
  y: 22.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 10.25,
  y: 25.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 13.25,
  y: 1.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 13.25,
  y: 4.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 13.25,
  y: 7.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 13.25,
  y: 10.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 13.25,
  y: 13.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 13.25,
  y: 16.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 13.25,
  y: 19.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 13.25,
  y: 22.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 13.25,
  y: 25.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 13.25,
  y: 28.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 16.25,
  y: 1.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 16.25,
  y: 4.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 16.25,
  y: 7.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 16.25,
  y: 10.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 16.25,
  y: 13.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 16.25,
  y: 16.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 16.25,
  y: 19.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 16.25,
  y: 22.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 16.25,
  y: 25.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  x: 16.25,
  y: 28.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 19.25,
  y: 4.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  x: 19.25,
  y: 7.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref48 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 19.25,
  y: 10.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 19.25,
  y: 13.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref50 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 19.25,
  y: 16.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref51 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 19.25,
  y: 19.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  x: 19.25,
  y: 22.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref53 = /*#__PURE__*/React.createElement("rect", {
  x: 19.25,
  y: 25.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref54 = /*#__PURE__*/React.createElement("rect", {
  x: 22.25,
  y: 4.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref55 = /*#__PURE__*/React.createElement("rect", {
  x: 22.25,
  y: 7.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref56 = /*#__PURE__*/React.createElement("rect", {
  x: 22.25,
  y: 10.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref57 = /*#__PURE__*/React.createElement("rect", {
  x: 22.25,
  y: 13.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref58 = /*#__PURE__*/React.createElement("rect", {
  x: 22.25,
  y: 16.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref59 = /*#__PURE__*/React.createElement("rect", {
  x: 22.25,
  y: 19.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref60 = /*#__PURE__*/React.createElement("rect", {
  x: 22.25,
  y: 22.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref61 = /*#__PURE__*/React.createElement("rect", {
  x: 22.25,
  y: 25.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref62 = /*#__PURE__*/React.createElement("rect", {
  x: 25.25,
  y: 7.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref63 = /*#__PURE__*/React.createElement("rect", {
  x: 25.25,
  y: 10.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref64 = /*#__PURE__*/React.createElement("rect", {
  x: 25.25,
  y: 13.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref65 = /*#__PURE__*/React.createElement("rect", {
  x: 25.25,
  y: 16.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref66 = /*#__PURE__*/React.createElement("rect", {
  x: 25.25,
  y: 19.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref67 = /*#__PURE__*/React.createElement("rect", {
  x: 25.25,
  y: 22.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref68 = /*#__PURE__*/React.createElement("rect", {
  x: 28.25,
  y: 13.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref69 = /*#__PURE__*/React.createElement("rect", {
  x: 28.25,
  y: 16.25,
  width: 2.5,
  height: 2.5,
  rx: 1.25,
  fill: "#212121"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M42.883 3.52734V23.069C42.883 25.0292 43.4215 25.5368 45.0445 25.5368C45.5746 25.5321 46.1039 25.4959 46.6298 25.4284V27.9699C45.9759 28.0895 45.3127 28.1501 44.6482 28.1511C41.9461 28.1511 40 27.2073 40 22.9974V3.52734H42.883Z",
  fill: "#212121"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M60.9971 27.9329V25.2091H60.7817C60.0612 26.552 58.295 28.4752 54.8724 28.4752C51.5209 28.4752 48.71 26.6247 48.71 22.3779V9.49219H51.593V21.6522C51.593 24.0473 52.7098 25.9348 55.5929 25.9348C58.7635 25.9348 60.9982 23.6839 60.9982 20.9623V9.49219H63.8801V27.9329H60.9971Z",
  fill: "#212121"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8566 9.49268V12.2165H70.072C70.7925 10.8736 72.5587 8.94922 75.9813 8.94922C79.3328 8.94922 82.1437 10.8009 82.1437 15.0466V27.9334H79.2574V15.7734C79.2574 13.3772 78.1406 11.4908 75.2576 11.4908C72.087 11.4908 69.8523 13.7047 69.8523 16.4264V27.9334H66.98V9.49268H69.8566Z",
  fill: "#212121"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M84.55 18.6403C84.55 12.7241 88.0458 8.94922 93.4888 8.94922C98.8575 8.94922 101.997 12.5788 101.997 17.9873C101.997 18.5297 101.997 19.148 101.96 19.4387H87.5784C87.6506 22.7049 89.4879 25.971 93.5232 25.971C97.1268 25.971 98.4967 23.5401 98.8208 22.233H101.739C100.802 25.6814 98.208 28.4757 93.4877 28.4757C87.6861 28.4757 84.55 24.2658 84.55 18.6403ZM98.9275 16.8982C98.9275 13.849 96.766 11.4539 93.3423 11.4539C90.1717 11.4539 87.7572 13.6679 87.5773 16.8982H98.9275Z",
  fill: "#212121"
});

function SvgLuneLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 32,
    viewBox: "0 0 104 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuneLogo);
export default __webpack_public_path__ + "static/media/lune-logo.68f44b49.svg";
export { ForwardRef as ReactComponent };